import { useRef } from "react";
import { Box, Grid, Text } from "@chakra-ui/react";
import { useCountUp, useReveal } from "../hooks/landingEffects";

const STATS = [
  { value: "5", label: "Retailers integrated" },
  { value: "75+", label: "Suppliers onboard" },
  { value: "4,000+", label: "Stores tracked" },
  { value: "5+ yrs", label: "Of history at your fingertips" },
];

const StatItem = ({ value, label, isLast }) => {
  const ref = useRef(null);
  useCountUp(ref, value);
  return (
    <Box
      textAlign="center"
      px="12px"
      borderRight={isLast ? "none" : { base: "none", md: "1px solid rgba(255,255,255,0.08)" }}
    >
      <Text
        ref={ref}
        fontSize="40px"
        fontWeight={700}
        letterSpacing="-0.02em"
        sx={{
          background: "linear-gradient(90deg, #74ebd5, #ec4899)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
          fontVariantNumeric: "tabular-nums",
        }}
        lineHeight="1"
      >
        {value}
      </Text>
      <Text
        fontSize="11px"
        color="rgba(230,236,245,0.65)"
        mt="8px"
        textTransform="uppercase"
        letterSpacing="0.1em"
        fontWeight={600}
      >
        {label}
      </Text>
    </Box>
  );
};

const StatsStrip = () => {
  const ref = useRef(null);
  useReveal(ref);

  return (
    <Box
      ref={ref}
      className="lp-reveal"
      mx="auto"
      maxW="1200px"
      mt="100px"
      mb="30px"
      px="28px"
      py="32px"
      borderRadius="20px"
      bg="linear-gradient(135deg, rgba(4,174,193,0.18), rgba(99,102,241,0.18) 60%, rgba(236,72,153,0.18))"
      border="1px solid rgba(255,255,255,0.10)"
      backdropFilter="blur(14px)"
    >
      <Grid templateColumns={{ base: "repeat(2, 1fr)", md: "repeat(4, 1fr)" }} gap="20px">
        {STATS.map((stat, i) => (
          <StatItem
            key={stat.label}
            value={stat.value}
            label={stat.label}
            isLast={i === STATS.length - 1}
          />
        ))}
      </Grid>
    </Box>
  );
};

export default StatsStrip;
